import React from 'react';
import { RotationMsgWrapper, RotationMsgLeftWrapper, ExclamationTriangleIcon } from './RotationSyncMsg.styles';
import { useRotationStore } from '../../../context/RotationContext';
import useRotation from '../../../app/useRotation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RotationSyncMsgComponent: React.FC = () => {
    const { rotation } = useRotationStore();
    const { rotationAndImosSyncNotUpToDateMsg, rotationAndImosSyncNotUpToDateTooltip } = useRotation();

    const warningButton = () => {
        return (
            <ExclamationTriangleIcon>
                <FontAwesomeIcon icon="exclamation-triangle" />
            </ExclamationTriangleIcon>
        );
    };

    const getAndShowMsg = () => {
        if (rotation) {
            const msg = rotationAndImosSyncNotUpToDateMsg(rotation);
            const tooltip = rotationAndImosSyncNotUpToDateTooltip(rotation);
            if (msg) {
                return (
                    <RotationMsgWrapper title={tooltip}>
                        <RotationMsgLeftWrapper>{warningButton()}</RotationMsgLeftWrapper>
                    </RotationMsgWrapper>
                );
            }
        }
        return '';
    };

    return <>{getAndShowMsg()}</>;
};

export default RotationSyncMsgComponent;
